var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-col",
    { attrs: { xs: "12", "no-margin": "" } },
    [
      _c("w-tabs", {
        attrs: { tabs: _vm.tabs },
        model: {
          value: _vm.selectedTab,
          callback: function ($$v) {
            _vm.selectedTab = $$v
          },
          expression: "selectedTab",
        },
      }),
      _vm.selectedTab == 0
        ? _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { xs: "6" } },
                [
                  _c("w-select", {
                    attrs: {
                      value: _vm.startMonth,
                      items: _vm.months,
                      label: _vm.$ct("start-month"),
                      fancy: "",
                    },
                    on: {
                      input: function ($event) {
                        return _vm.setStartMonth($event)
                      },
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { xs: "6" } },
                [
                  _c("w-select", {
                    attrs: {
                      value: _vm.endMonth,
                      items: _vm.months,
                      label: _vm.$ct("end-month"),
                      fancy: "",
                    },
                    on: {
                      input: function ($event) {
                        return _vm.setEndMonth($event)
                      },
                    },
                  }),
                ],
                1
              ),
            ],
            1
          )
        : [
            _c(
              "w-row",
              [
                _c(
                  "w-col",
                  { attrs: { xs: "6" } },
                  [
                    _c("w-radio", {
                      attrs: {
                        name: _vm.id,
                        label: _vm.getQuarterLabel("1"),
                        checked: _vm.isQuarterSelected(1),
                      },
                      on: {
                        input: function ($event) {
                          return _vm.selectQuarter(1)
                        },
                      },
                    }),
                    _c("w-radio", {
                      attrs: {
                        name: _vm.id,
                        label: _vm.getQuarterLabel("2"),
                        checked: _vm.isQuarterSelected(2),
                      },
                      on: {
                        input: function ($event) {
                          return _vm.selectQuarter(2)
                        },
                      },
                    }),
                    _c("w-radio", {
                      attrs: {
                        name: _vm.id,
                        label: _vm.getQuarterLabel("all"),
                        checked: _vm.isYearSelected(),
                      },
                      on: {
                        input: function ($event) {
                          return _vm.selectYear()
                        },
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "w-col",
                  { attrs: { xs: "6" } },
                  [
                    _c("w-radio", {
                      attrs: {
                        name: _vm.id,
                        label: _vm.getQuarterLabel("3"),
                        checked: _vm.isQuarterSelected(3),
                      },
                      on: {
                        input: function ($event) {
                          return _vm.selectQuarter(3)
                        },
                      },
                    }),
                    _c("w-radio", {
                      attrs: {
                        name: _vm.id,
                        label: _vm.getQuarterLabel("4"),
                        checked: _vm.isQuarterSelected(4),
                      },
                      on: {
                        input: function ($event) {
                          return _vm.selectQuarter(4)
                        },
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }